export default __webpack_public_path__ + "static/media/wechat-concat-02.b7a0f1b1.jpg";